class ImageContentTabs extends HTMLElement {

    constructor() {
        super()
        this.init()
    }

    private init() {
        this.initClickEvent()
    }

    private initClickEvent() {
        const buttons = this.querySelectorAll('.image-content-tabs__button');

        if (!buttons) {return}

        buttons.forEach((button) => {
            button.addEventListener('click', (event) => {
                const buttonEl = <HTMLButtonElement>event.target;
                const target = buttonEl.dataset.target
                this.activeTab(target)
            });
        })
    }

    private activeTab ( target: string | undefined ) {
        const imageTabs = this.querySelectorAll('.image-content-tabs__tab-image') 
        const contentTabs = this.querySelectorAll('.image-content-tabs__tab-content')
        const buttons = this.querySelectorAll('.image-content-tabs__button');

        imageTabs.forEach((imageTab) => {
            if ( imageTab.getAttribute('data-id') == target ) {
                imageTab.classList.add('active')
            } else {
                imageTab.classList.remove('active')
            }
        })

        contentTabs.forEach((contentTab) => {
            if ( contentTab.getAttribute('data-id') == target ) {
                contentTab.classList.add('active')
            } else {
                contentTab.classList.remove('active')
            }
        })

        buttons.forEach((button) => {
            if ( button.getAttribute('data-target') == target ) {
                button.classList.add('active')
            } else {
                button.classList.remove('active')
            }
        })
    }
}

export default ImageContentTabs